module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"subscription_confirmed":"Subscription confirmed."},"zhHant":{"subscription_confirmed":"訂閱已確認"},"ja":{"subscription_confirmed":"ご契約が完了しました"},"ko":{"subscription_confirmed":"구독이 확인되었습니다"}}')
  delete Component.options._Ctor
}
